const parseName = (fullName?: string): { firstName: string; lastName: string } => {
    if (!fullName) {
        return { firstName: '', lastName: '' };
    }

    const [firstName, ...rest] = fullName.trim().split(/\s+/);
    const lastName = rest.length > 0 ? rest[rest.length - 1] : '';

    return { firstName, lastName };
};

export default parseName;
